import { graphql } from '../gql';
import { useMutation } from '@apollo/client';
import type { ClaimInput } from '../gql/graphql';
import { GET_CLAIM_INFORMATION } from './getClaimInformation.query';

export const UPSERT_CLAIM_INFORMATION = graphql(`
  mutation upsertClaimInformation($claimInput: ClaimInput!) {
    upsertClaim(details: $claimInput) {
      uuid
      potentialCoveragesImpacted
      additionalCoveragesImpacted
      description
    }
  }
`);

export interface IUseUpsertClaimInformationMutationArg {
  claimInput: ClaimInput;
}

export function useUpsertClaimInformationMutation() {
  const [upsertClaimInformation, { loading, error, data }] = useMutation(
    UPSERT_CLAIM_INFORMATION,
    { refetchQueries: [GET_CLAIM_INFORMATION], awaitRefetchQueries: true }
  );

  const executeUpsertClaimInformation = (
    variables: IUseUpsertClaimInformationMutationArg
  ) => {
    return upsertClaimInformation({
      variables,
    });
  };

  return {
    upsertClaimInformation: executeUpsertClaimInformation,
    loading,
    error,
    data,
  };
}
